/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { LedgerDepositOptions, LedgerDepositResponses } from '../types/LedgerDeposit'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Deposit assets into this user's account from the outside world. Note that this does not interact with any external systems; it simply adds the amount to the user's available balance in the ledger. Actual transfer of assets must be handled separately.
 * @summary Deposit assets into this user's account from the outside world
 * {@link /v1/ledger/deposit/:user_id}
 */
export function ledgerDeposit<ThrowOnError extends boolean = true>(
  options: Options<LedgerDepositOptions, ThrowOnError>,
): Unwrappable<RequestResult<LedgerDepositResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/ledger/deposit/{user_id}',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<LedgerDepositResponses, ThrowOnError>>,
  )
}
